export default {
    title: 'Table columns',
    button: {
        cancel: 'Close'
    }
}
